import { useQuery } from '@tanstack/react-query';

import { fetchChecklist } from 'api/photo-session';

export const getKey = () => ['checklist-items'];

const useChecklistItems = options =>
  useQuery(getKey(), () => fetchChecklist(), options);

export default useChecklistItems;
